import React from "react";
import ErrorMessage from "../ErrorMessage";
import "./input.css";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';

export function DropDown(props: any) {
  const {
    field,
    form: { touched, errors, setFieldValue },
    showerror = "true",
    Data,
    width = "100%",
    height = "54px",
    backgroundcolor = "#fff",
    placeholder,
    value,
    readOnly,
  } = props;
  const [accountName, setAccountName] = React.useState([value ? value : placeholder]);
  const onChangeText = (e: any) => {
    const {
      target: { value },
    } = e;
    setAccountName(
      typeof value === 'string' ? value.split(',') : value,
    );
    setFieldValue(field.name, e.target.value);
    if (props.onChange) props.onChange(e.target.value);
  };
  return (
    <>
      <Select
        // className= {(accountName.length === 0 || (accountName[0] === 'Savings' || accountName[0] === 'Current')) ? "cuDropdown-light-color" : "cuDropdown"}
         className={readOnly !== false && readOnly !== undefined ? 'cuDropdown' : accountName[0] === 'gender' ? 'CustumPlaceholder cuDropdown-light-color ' : 'cuDropdown-light-color' }
        style={{
          width: width,
          height: height,
          backgroundColor: backgroundcolor,
        }}
        displayEmpty
        onChange={(name: any) => {
          onChangeText(name);
        }}
        readOnly={readOnly}
        value={value ? [value] : accountName}
        renderValue={(selected) => {
          if (selected.length === 0) {
            return <span>{placeholder}</span>;
          }

          return selected.join(', ');
        }}
      >
          {Data?.map((name:any) => (
            <MenuItem
              key={name}
              value={name}
            >
              {name}
            </MenuItem>
          ))}
      </Select>
      {/* <select
        className=""
        onChange={(name: any) => {
          onChangeText(name);
        }}
        style={{
          width: width,
          height: height,
          backgroundColor: backgroundcolor,
        }}
      >
        <option value="">{title}</option>
        {Data?.map((value: any) => {
          return (
            <>
              <option value={value.name}> {value.name} </option>
            </>
          );
        })}
      </select> */}
      {showerror === "true" && errors[field.name] && touched[field.name] && (
        <ErrorMessage text={errors[field.name]} />
      )}
    </>
  );
}
